import PropTypes from "prop-types";
import * as React from "react";
import { useStateValue } from "../../../globalState";
import css from "./AdvancedSettings.module.css";
import ToggleAttribute from "../InfluencerModal/ToggleAttribute";
import { TOGGLE_ATTRIBUTES } from "./utils";

export default function ShopToggles({ influencer }) {
  const [{ user }] = useStateValue();
  const isAdmin = Boolean(user.admin);
  const isGroupShop = Boolean(influencer.group_shop);

  return (
    <div className={css.toggleColumn}>
      {TOGGLE_ATTRIBUTES.filter((attr) => {
        if (attr.adminOnly && !isAdmin) return false;
        if (attr.groupShopOnly && !isGroupShop) return false;
        if (attr.nonGroupShopOnly && isGroupShop) return false;
        return true;
      }).map((attr) => (
        <ToggleAttribute
          key={attr.key}
          attributeKey={attr.key}
          attributeValue={Boolean(influencer[attr.key])}
          influencerId={influencer.influencer_id}
          displayName={attr.displayName}
        />
      ))}
    </div>
  );
}

ShopToggles.propTypes = {
  influencer: PropTypes.shape({
    influencer_id: PropTypes.number.isRequired,
    group_shop: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  }).isRequired,
};
